// extracted by mini-css-extract-plugin
export var defaultWrapper = "_j4-3";
export var downloadButton = "_j4-4";
export var fileContainer = "_j4-9 _j4-7";
export var fileContainerBase = "_j4-7";
export var fileContainerFixedHeight = "_j4-8 _j4-7";
export var fileInfo = "_j4-5";
export var fileInfoWidthRestricted = "_j4-6";
export var fileType = "_j4-1";
export var fileTypeName = "_j4-2";
export var image = "_j4-0";
export var link = "_j4-b";
export var overflowEllipsis = "_j4-a";